export const isProcessingAuthorizedBooking = (bookingStatus: any): boolean => {
  return bookingStatus?.booking_status === "processing" && bookingStatus?.payment_status === "authorized";
};
